import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SuccessModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm transition-all">
      <div className="bg-white dark:bg-gray-900 text-center p-6 rounded-2xl shadow-2xl w-full max-w-md animate-fade-in">
        <CheckCircle className="w-16 h-16 mx-auto mb-4 text-green-500" />

        <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">
          {t('partnerJoin.success.title')}
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          {t('partnerJoin.success.description')}
        </p>

        <button
          onClick={onClose}
          className="w-full py-3 rounded-xl font-semibold bg-primaryAccent hover:bg-primaryAccent/90 text-white transition-colors"
        >
          {t('partnerJoin.success.close')}
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
